import React, { useCallback, useEffect, useState } from 'react';
import { Card, Table } from 'antd';
import LocationBuskDetailStock from '../components/Location';
import { useParams } from 'react-router';
import buskStockWarehouseService from '../services/buskstockwarehouse';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import { ColumnsType } from 'antd/lib/table';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface DataType {
  key: React.Key;
  no: number;
  quantity: number;
  status: string;
  update_at: Date;
}

const breadcrumbList = [
  {
    tittle: '재고 관리',
    url: '/admin/busk/stock'
  },
  {
    tittle: '재고 상세',
    url: ''
  }
];

const BuskStockDetail = () => {
    const [info, setInfo] = useState({} as any);
    const [product , setProduct] = useState({} as any);
    const { id,warehouseid, productId }: any = useParams();
    const [loading , setLoading] = useState(false);
    const [list, setList] = useState([] as any);
    const [totalPages, setTotalPages] = useState(1);
    const [sort, setSort] = useState(false);
    const [totalOrder, setTotalOrder] = useState(0)
const columns: ColumnsType<DataType> = [
      {
        title: "주문번호",
        dataIndex: "orderNumber",
      },
      {
        title: "수량",
        dataIndex: "orderProducts",
        render: (orderProducts: any) => orderProducts[0].orderQuantity,
      },
  
      {
        title: "상태",
        dataIndex: "status",
      },
      {
        title: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
           업데이트일

            {!sort ? (
              <DownOutlined
                style={{ marginLeft: "15px" }}
                onClick={() => {
                  setSort(true);
                }}
              />
            ) : (
              <UpOutlined
                style={{ marginLeft: "15px" }}
                onClick={() => setSort(false)}
              />
            )}
          </div>
        ),
        dataIndex: "updated_at",
        // key: "updated_at",
      },
    ];


  const getStockDetail = useCallback(async () => {
    const stockDetail = await buskStockWarehouseService.getDetailStock(
      warehouseid,
      id,
    );
    setInfo(stockDetail.data);
    let product = stockDetail.data.product;
    product.dangerousGoods = !!stockDetail.data.product.dangerousGoods
      ? 'Yes'
      : 'No';
    setProduct(stockDetail.data.product);
  }, [id, warehouseid]);

  const getPagination = async (
    warehouseId: number,
    stockId: number,
    page: number,
    sort: boolean
  ) => {
    try {
      setLoading(true);
      const detailProduct = await buskStockWarehouseService.getPaginationOrder(
        warehouseId,
        stockId,
        productId,
        page,
        sort,
      );
      let listProduct = [];
      if (detailProduct?.data?.res.length > 0) {
        listProduct = detailProduct.data.res.map((item: any) => ({
          ...item,
          updated_at: item.updatedAt ? formatDateTime(item.updatedAt) : ''
        }));
      }
      setList(listProduct);
      setTotalPages(
        Number((detailProduct.count / 10).toFixed(0)) +
          (detailProduct.count % 10 !== 0 && detailProduct.count > 10 ? 1 : 0)
      );
      setTotalOrder(detailProduct.count);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStockDetail();
  }, [getStockDetail]);

  useEffect(() => {
    getPagination(warehouseid, id, 1, sort);
  }, [id, sort, warehouseid]);

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <LocationBuskDetailStock
            id={Number(info.id || 1)}
            location={info?.location}
          />
          <div style={{ backgroundColor: 'white', padding: '19px' }}>
            {!!product.productName && (
              <DetailsPro
                img={product?.image?.url}
                productName={product.productName}
                width={product.width}
                height={product.height}
                length={product.length}
                demensionUnit={product.demensionUnit}
                weight={product.weight}
                weightUnit={product.weightUnit}
                estimateQuantity={product.estimateQuantity}
                averageMonthSale={product.averageMonthSale}
                sku={product.sku}
                eanUpc={product.eanUpc}
                asin={product.asin}
                packedMethod={product.packedMethod}
                storageMethod={product.storageMethod}
                dangerousGoods={product.dangerousGoods}
                lotProduct={product.lotProduct}
              />
            )}
          </div>
          <Table
            loading={loading}
            columns={columns}
            dataSource={list}
            pagination={{
              total: totalOrder * 5,
              onChange: (page, limit) => {
                getPagination(warehouseid, id, page, sort);
              }
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default BuskStockDetail;
